'use client';
import { MotionDiv } from '@lib/motion';
import React from 'react';
import { usePricingFrequency } from '../PricingMain/PricingFrequencyContext';
import cn from '@utils/cn';
import { TextVariant } from '@ui/Text/constants';
import PortableText from '@ui/Text/PortableText';
import { FrequencySwitchProps } from '.';

const FrequencySwitchDesktop = ({ data }: FrequencySwitchProps) => {
  const { isYearlyFrequency, setIsYearlyFrequency } = usePricingFrequency();
  const firstHeroPricing = data?.[0];
  if (!data || !firstHeroPricing) {
    return null;
  }
  const isYearly = isYearlyFrequency;
  const isMonthly = !isYearlyFrequency;
  const switcherRGB = firstHeroPricing.switcherColor?.rgb;

  const chip = (
    <MotionDiv
      layoutId="frequency"
      transition={{ type: 'spring', bounce: 0, duration: 0.3 }}
      style={{
        backgroundColor: `rgba(${switcherRGB?.r},${switcherRGB?.g},${switcherRGB?.b},${switcherRGB?.a})`,
      }}
      className="absolute h-[calc(100%-4px)] w-[calc(50%-4px)] rounded-full"
    />
  );

  return (
    <div className="flex w-full items-center justify-center px-2 py-5">
      <div
        className="relative flex h-[42px] w-[384px] items-center justify-around gap-2 rounded-full
                border-[1px] p-1"
        onClick={() => setIsYearlyFrequency(!isYearly)}
      >
        <div key={1} className={cn('flex h-full w-full cursor-pointer items-center justify-center rounded-full')}>
          {isMonthly && chip}
          <PortableText
            className={cn({ 'z-10 text-white': isMonthly })}
            content={firstHeroPricing.switcherLeftLabel}
            variant={TextVariant.TextBodySM}
          />
        </div>
        <div key={2} className={cn('flex  h-full w-full cursor-pointer items-center justify-center rounded-full')}>
          {isYearly && chip}
          <PortableText
            className={cn({ 'z-10 text-white': isYearly })}
            content={firstHeroPricing.switcherRightLabel}
            variant={TextVariant.TextBodySM}
          />
        </div>
      </div>
    </div>
  );
};

export default FrequencySwitchDesktop;
